import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

import subscriptions from "./Subscriptions";
import questionnaires from "./Questionnaires";
import account from "./Account";
import help from "./Help";
import configuration from "./Configuration";
import legalAgreementsRoutes from "./LegalAgreements";
import invoices from "./Invoices";
import patientReferral from "./PatientReferral";
import payments from "./PaymentReceipts";

import { buildBeforeEnterChain, isTherapistGuard } from "@/Router/guards";

const settings: RouteRecordRaw[] = [
  {
    path: SETTINGS.root.path,
    components: {
      sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
      main: () => import("@/Views/MainLanding.vue"),
    },
    meta: { sidebar: true, drawer: false },
    children: [
      {
        ...SETTINGS.root,
        component: () => import("@/Views/settings/index.vue"),
        meta: {
          noHeader: true,
        },
      },

      {
        ...SETTINGS.loyaltyPlan.root,
        meta: {
          i18nTitle: "settings.loyalty_plan",
        },
        component: () => import("@/Views/settings/objectives/LoyaltyPlan.vue"),
        beforeEnter: buildBeforeEnterChain(isTherapistGuard),
      },
      {
        ...SETTINGS.privacy.root,
        meta: {
          i18nTitle: "settings.privacy.title",
        },
        component: () => import("@/Views/settings/privacy/index.vue"),
      },
      {
        ...SETTINGS.timeZone.root,
        component: () => import("@/Views/settings/configuration/TimeZone.vue"),
        meta: {
          i18nTitle: "settings.configuration.time_zone.title",
        },
      },
      configuration,
      ...account,
      ...questionnaires,
      ...help,
      ...legalAgreementsRoutes,
      ...invoices,
      ...payments,
      ...patientReferral,
    ],
  },

  ...subscriptions,
];
export default settings;
